module.exports = __webpack_public_path__ + "036a85a5921308de489a9dfb37603913.jpg";